// extracted by mini-css-extract-plugin
export default {"cls1":"Z2ttXrZObpF3G3JsRH9O","cls2":"oIVLIB_VAk_a4xoL8MeK Z2ttXrZObpF3G3JsRH9O"};